export default "__VITE_ASSET__B2rChE8g__"